import React from 'react'
import {useAsync, useSearchParam} from 'react-use'
import {applyTheme, useSession} from '../lib'
import {Authenticating} from '.'
import PublicApp from './PublicApp'
import PrivateApp from './PrivateApp'

export default function App() {
  const session = useSession()
  const settings = session.getSettings()
  const scopedUserId = Number(useSearchParam('scope'))
  useAsync(async () => {
    session.signIn(scopedUserId)
  }, [scopedUserId])
  React.useEffect(() => {
    if (settings?.theme) {
      applyTheme(settings.theme)
    }
  }, [settings?.theme])
  if (!session.fetched) {
    return <Authenticating />
  }
  return session.user ? <PrivateApp /> : <PublicApp />
}
